export default __webpack_public_path__ + "static/media/filters.446d8637.svg";